export function Contact() {
    return <div>Contact</div>
}
